export const syndicationChannels = [
  'allHomes',
  'domain',
  'facebook',
  'google',
  'generic',
  'instagram',
  'linkedIn',
  'onTheHouse',
  'realtor',
  'reiwa',
  'rma',
  'soho',
  'twitter',
  'widget',
  'zillow',
  'yelp',
] as const;

export type SyndicationChannel = (typeof syndicationChannels)[number];

export interface SyndicationChannelSettings {
  name: SyndicationChannel;
  useBaseIcon?: boolean;
}

export function mapChannelNamesToSettings(c: SyndicationChannel[] | SyndicationChannelSettings[]): SyndicationChannelSettings[] {
  return c.map((d: SyndicationChannel | SyndicationChannelSettings) => {
    return typeof d === 'string' ? { name: d } : d;
  });
}
